export default __webpack_public_path__ + "media/zurb/img/work/iqtell-thumb-6eb002b2864e359f07815f750dc73d1b.png";